import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';

import BaseLayout from '../../layouts/BaseLayout';
import { Pagination } from '../../components';
import PostTeaser from '../../partials/blog/PostTeaser';

const List = props => {
  const {
    data: {
      allMarkdownRemark: { edges },
    },
    pageContext: { hasPrevPage, prevPageLink, hasNextPage, nextPageLink },
  } = props;
  const isFirstPage = !hasPrevPage;
  // Skip first post if it's the first page to show featured post
  const pageEdges = isFirstPage ? edges.slice(1) : edges;

  return (
    <BaseLayout headerProps={{ contrast: false }}>
      <Helmet title="Breaking Things on Purpose | Gremlin Blog" />
      <div className="static-wrapper">
        <section className="section">
          <div className="container">
            {isFirstPage && (
              <PostTeaser
                featured
                title={edges[0].node.frontmatter.title}
                link={edges[0].node.fields.fullUrl}
                excerpt={edges[0].node.excerpt}
                featuredImage={edges[0].node.fields.featuredImage}
                author={edges[0].node.frontmatter.author}
                authorUrl={edges[0].node.fields.authorUrl}
              />
            )}
            {pageEdges.length > 0 && (
              <ul className="blockGrid blockGrid-2@small blockGrid--largeGutter">
                {pageEdges.map(({ node }) => (
                  <li key={node.fileAbsolutePath}>
                    <PostTeaser
                      title={node.frontmatter.title}
                      link={node.fields.fullUrl}
                      excerpt={node.excerpt}
                      featuredImage={node.fields.featuredImage}
                      author={node.frontmatter.author}
                      authorUrl={node.fields.authorUrl}
                    />
                  </li>
                ))}
              </ul>
            )}
            <Pagination
              hasPrevPage={hasPrevPage}
              hasNextPage={hasNextPage}
              prevPageLink={prevPageLink}
              nextPageLink={nextPageLink}
            />
          </div>
        </section>
      </div>
    </BaseLayout>
  );
};

List.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default List;

export const pageQuery = graphql`
  query BlogList($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      skip: $skip
      limit: $limit
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        fileAbsolutePath: { regex: "/src/posts/" }
        frontmatter: { title: { ne: "BLUEPRINT" } }
      }
    ) {
      edges {
        node {
          ...PostTeaserFragment
        }
      }
    }
  }
`;
